export default function PageHero({
                                     kicker,
                                     title,
                                     children,
                                     actions = null,
                                 }) {
    return (
        <section className="rv-page-hero">
            <div className="rv-page-hero__inner">
                <div>
                    {kicker && (
                        <div className="rv-page-kicker">
                            {kicker}
                        </div>
                    )}

                    <h1 className="rv-page-title">
                        {title}
                    </h1>

                    {children && (
                        <div className="rv-page-subtitle">
                            {children}
                        </div>
                    )}
                </div>

                {actions && (
                    <div className="rv-page-actions">
                        {actions}
                    </div>
                )}
            </div>
        </section>
    );
}